<template>
  <div id="order_history">
    <call />
    <pop-alert />
    <!-- header -->
    <header>
      <header-app :rate="counterBlock" :canMobileOrder="isMobileOrderEnabled()" :orderNumOverride="0"></header-app>
      <span><menu-app></menu-app></span>
      <div class="ssm-overlay ssm-toggle-nav"></div>
    </header>
    <!-- main -->
    <main>
      <!-- menu detail -->
      <section>
        <div class="l-main l-main--bg-border l-main--bg-border--green pt-60">
          <div class="l-main__head">
            <router-link
              to="/mobileorder"
              class="l-main__head--control l-main__head--control--back"
            >
              <img src="/assets/images/icon/icon-back-white.svg?v=2" alt="" />
            </router-link>
            <div class="l-main__head--title">注文・予約状況、履歴</div>
            <button class="l-main__head--btn-close" @click.prevent="$router.push('/mobileorder')">
              <img src="/assets/images/icon/icon-close-black.svg" alt="" />
            </button>
          </div>
          <div class="l-check-cart">
            <div class="l-check-cart__body l-check-cart__body--grey">
              <div :class="{'c-history-detail':true, 'mb-8': true, 'processing': isProcessing(order.status), 'completed': isCompleted(order.status), 'cancelled': isCancelled(order.status),'is-reservation':order.orderType == 3 }" v-for="(order, index) in orders" :key="index">
                <div class="c-history-detail__content">
                  <div class="c-history-detail__content--time mb-8 d-flex" @click.prevent="showOrderDetail(order.id)">
                    <div>{{formatDateForOrder(order.aeonRegiPaymentRequestTime)}} <span>{{formatTimeForOrder(order.aeonRegiPaymentRequestTime)}}</span></div>
                    <div>{{deliveryMethod(order)}}</div>
                  </div>
                  <div class="c-history-detail__content--title mb-8" @click.prevent="showOrderDetail(order.id)">
                    <div class="icon">
                      <img :src="getImgSrc(order.provider && order.provider.image && order.provider.image[0])" alt="" />
                    </div>
                    <div class="title">{{order.provider.shopName}}</div>
                  </div>
                  <div class="c-history-detail__receipt" @click.prevent="showOrderDetail(order.id)">
                    <div class="receipt">
                      <span>{{order.orderType == '3' ? 'ご予約' : '受け取り'}}番号</span>
                      {{order.deliveryNumber | formatDeliveryNumber}}
                    </div>
                    <div class="shippingTime" v-if="order.status != 'COMPLETED'">
                      <span>{{order.orderType == '3' ? 'ご来店' : '受け取り'}}目安</span>
                      <div class="day" v-if="order.orderType == 3 || order.orderType == 1">
                        <div v-if="formatTimeForOrder(order.estimatedShippingTime,'day')">{{formatTimeForOrder(order.estimatedShippingTime,"day")}}</div>
                        <div>{{formatTimeForOrder(order.estimatedShippingTime)}}</div>
                      </div>
                      <template v-else>
                      {{formatTimeForOrder(order.estimatedShippingTime)}}
                      </template>
                    </div>
                    <div class="shippingTime" v-if="order.status == 'COMPLETED'">
                      <span>{{order.orderType == '3' ? 'ご来店' : '受け取り'}}日時</span>
                      {{order.completeTime && formatTimeForOrder(order.completeTime)}}
                    </div>
                    <div class="status">
                      <span>ステータス</span>
                      <div :class="{ CancelFailed: order.status == 'CANCEL_FAILED' }">
                        {{orderStatus(order)}}
                      </div>
                    </div>
                  </div>
                  <div class="c-history-detail__place" v-if="order.handlingFormat == '3' || order.handlingFormat == '4' || (order.handlingFormat == '2' && order.deliveryPlaceDetail && order.deliveryPlaceDetail.tableNo)">
                    <span>受け取り場所</span>
                    <template v-if="order.handlingFormat == '2'">店内でお食事　テーブル番号：{{order.deliveryPlaceDetail && order.deliveryPlaceDetail.tableNo}}</template>
                    <template v-if="order.handlingFormat == '3'">{{mobileOrderConfig.drivethruAreaName}} {{order.deliveryPlaceDetail && order.deliveryPlaceDetail.carNo}} ({{order.deliveryPlaceDetail && order.deliveryPlaceDetail.carColor}})</template>
                    <template v-if="order.handlingFormat == '4'">{{mobileOrderConfig.parkAndPickupAreaName}} {{order.deliveryPlaceDetail && order.deliveryPlaceDetail.parkingNo}} {{order.deliveryPlaceDetail && order.deliveryPlaceDetail.carNo}} ({{order.deliveryPlaceDetail && order.deliveryPlaceDetail.carColor}})</template>
                  </div>
                  <div class="deliveryHelp" v-if="(shop && shop.deliveryContact) && (order.handlingFormat == '3' || order.handlingFormat == '4')"><a href="#" @click.prevent="openDeliveryHelp">お受け取りでお困りの場合はこちら</a></div>
                  <div class="c-order-info__body" v-if="(order.orderType == 1 && order.status == 'PREPARED') || order.status == 'DELIVERING'">
                    <div class="c-btn c-btn--red mt-16 box-center" @click.prevent="changeStatusCompleted(order.id, order.tenantId)">
                      受け取りました
                    </div>
                  </div>
                  <!-- TODO 来店予約は一覧にボタンは必要ないため削除 -->
                  <!--　
                  <div class="c-order-info__body" v-if="order.orderType == 3 && order.status == 'PREPARED'">
                    <div class="c-btn c-btn--red mt-16 box-center" @click.prevent="changeStatusCompleted(order.id, order.tenantId)">
                      入店しました
                    </div>
                  </div>
                   -->
                </div>
                <div class="c-history-detail__icon" @click.prevent="showOrderDetail(order.id)">
                  <a href="#"
                    ><img src="/assets/images/icon/icon-arrow-right-white.svg" alt=""
                  /></a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <footer-cart></footer-cart>
      <div class="layer" :class="{ fade: !loading }"></div>
      <div class="screen-loader loader--style1" :class="{ fade: !loading }" title="0">
        <svg version="1.1" id="loader-1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="40px" height="40px" viewBox="0 0 40 40" enable-background="new 0 0 40 40" xml:space="preserve">
          <path opacity="0.2" fill="#000" d="M20.201,5.169c-8.254,0-14.946,6.692-14.946,14.946c0,8.255,6.692,14.946,14.946,14.946 s14.946-6.691,14.946-14.946C35.146,11.861,28.455,5.169,20.201,5.169z M20.201,31.749c-6.425,0-11.634-5.208-11.634-11.634 c0-6.425,5.209-11.634,11.634-11.634c6.425,0,11.633,5.209,11.633,11.634C31.834,26.541,26.626,31.749,20.201,31.749z"/>
          <path fill="#000" d="M26.013,10.047l1.654-2.866c-2.198-1.272-4.743-2.012-7.466-2.012h0v3.312h0 C22.32,8.481,24.301,9.057,26.013,10.047z"></path>
        </svg>
      </div>
       <alert :message="alert_msg" 
        :show="alert_show" 
        :closeModal="closeModal" 
        :confirm_show="confirm_show" 
        :confirm_message="confirm_msg" 
        :confirm_callback="confirm_callback" 
        :confirm_hide_cancel="confirm_hide_cancel"
        :label_cancel="confirm_label_cancel"
        :label_ok="confirm_label_ok"
        :confirm_title="confirm_title"
        :confirm_centering="confirm_centering"
      ></alert>
    </main>
  </div>
</template>

<script>
import "core-js/stable";
import "regenerator-runtime/runtime";
import Vue from "vue";
import Header from "../components/Header.vue";
import Menu from "../components/Menu.vue";
import Alert from "../components/Alert.vue";
import FooterCart from "../components/FooterCart.vue";
import { Common, eventBus } from "../common/common.js";
import { Tenant } from "../plugin/mixin.js";
import { getShop, getTagsByProvider, getMyOrders, getMobileOrderConfig } from "../store/firestore";
import firebase from "../common/firebaseProject";
import store from "../store";
import PopAlert from "../components/PopAlert.vue";

export default Vue.extend({
  name: "MobileOrderHistory",
  components: {
    'header-app': Header,
    'menu-app': Menu,
    'footer-cart': FooterCart,
    'alert': Alert,
    PopAlert
  },
  store,
  mixins: [Tenant],
  async created() {
    this.$store.dispatch('clearUnread');
    const shopId = this.$store.state.shopId;
    this.shop = await getShop(shopId);
    const userId = this.$store.state.userId;
    const orders = await getMyOrders(userId);
    this.loading = false;
    this.orders = orders;
    this.mobileOrderConfig = await getMobileOrderConfig();
    var _this = this;
    eventBus.$on('orderUpdated', async function(orderData, status, changedAt) {
      _this.loading = true;
      _this.orders = await getMyOrders(userId);
      _this.loading = false;
    });
  },
  data() {
    return {
      shop: undefined,
      orders: undefined,
      mobileOrderConfig: null,
      loading: true
    }
  },
  mounted() {
    Common.initDom();
  },
  methods: {
    orderStatus(order){
      if (order.orderType != 3) {
        switch(order.status){
          case "ORDER_SUCCEED":
            return "注文完了";
          case "ORDER_FAILED":
            return "注文エラー";
          case "PREPARING":
            return "商品準備中";
          case "PREPARED":
            if (order.handlingFormat == '1' || order.handlingFormat == '2') {
              return "お受け取り待ち";
            } else if (order.handlingFormat == '3' || order.handlingFormat == '4') {
              return "お届け準備中";
            }
            break;
          case "DELIVERING":
            return "お届け中";
          case "COMPLETED":
            return "受け取り完了";
          case "CANCEL_REQUESTED":
            return "キャンセル受付";
          case "CANCEL_SUCCEED":
            return "キャンセル済";
          case "CANCEL_FAILED":
            return "キャンセルエラー";
        }
      } else {
        switch(order.status) {
          case "ORDER_SUCCEED":
            return "ご予約完了";
          case "ORDER_FAILED":
            return "ご予約エラー";
          case "PREPARING":
            return "ご予約確定";
          case "PREPARED":
            return "ご来店待ち";
          case "COMPLETED":
            return "ご来店済み";
          case "CANCEL_REQUESTED":
            return "キャンセル受付";
          case "CANCEL_SUCCEED":
            return "キャンセル済";
          case "CANCEL_FAILED":
            return "キャンセルエラー";
        }
      }
    },
    deliveryMethod(order) {
      if (order.orderType == 1) {
        return "モバイルオーダー";
      } else if (order.handlingFormat == 3) {
        return "ドライブスルー";
      } else if (order.handlingFormat == 4) {
        return "駐車場受け取り";
      } else if (order.orderType == 3) {
        return "ご来店予約";
      }
    },
    showOrderDetail(orderId) {
      this.$router.push(`/mobileorder/history/item/${orderId}`);
    },
    isProcessing(status) {
      return ["ORDER_SUCCEED", "PREPARING", "PREPARED", "DELIVERING"].includes(status)
    },
    isCompleted(status) {
      return ["COMPLETED"].includes(status)
    },
    isCancelled(status) {
      return ["CANCEL_REQUESTED", "CANCEL_SUCCEED", "CANCEL_FAILED"].includes(status)
    },
    async changeStatusCompleted(orderId, tenantId) {
      const idToken = await this.getIdToken();
      if (!idToken) return;
      const callable = firebase.functions('asia-northeast1').httpsCallable('changeOrderStatus');
      const params = {
        tenantId: tenantId,
        orderId: orderId,
        status: "COMPLETED",
        iid: this.$store.state.installId
      };
      this.loadingShow();
      await callable(params)
      .then(() => {
        //OK
        this.loadingHide();
        this.$router.go();
      })
      .catch(err => {
        this.loadingHide();
        this.alert("ご注文ステータスが更新できませんでした。しばらくしてからご確認ください。");
      })
    }
  }
});
</script>